import { isValid, whenValid } from '@elements/parsley-bootstrap-validation';
import { sha256, rightRotate, hexInBin, extractBits, checkNonce } from './hash-cash-pow';

var elementsHashCash = {

    // full implementation of SHA265 hashing algorithm - shared with the Vue withdrawal
    // wizard's useHashCash composable via ./hash-cash-pow, not duplicated here
    sha256: sha256,

    // Only need for SHA256 Function
    rightRotate: rightRotate,

    // replace with your desired hash function
    hashString: function (toHash) {
        return elementsHashCash.sha256(toHash)
    },

    // set the data for a specific input
    setFormData: function (form, inputName, inputValue) {
        var z = form.querySelectorAll("[name=" + inputName + "]")[0]
        if (z) {
            z.value = inputValue;
        }
    },

    // get data from form input by name
    getFormData: function (form, inputName) {
        var z = form.querySelectorAll("[name=" + inputName + "]")[0]
        if (z)
            return z.value;
        else
            return '';
    },

    // convert hex char to binary string
    hexInBin: hexInBin,

    // gets the leading number of bits from the string
    extractBits: extractBits,

    // check if a given nonce is a solution for this stamp and difficulty
    // the $difficulty number of leading bits must all be 0 to have a valid solution
    checkNonce: checkNonce,

    // sleep Function for Calculating field ... we dont want to burn every pc
    sleep: function (ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },

    // iterate through as many nonces as it takes to find one that gives us a solution hash at the target difficulty
    findHash: async function (form) {
        var elhc_stamp = elementsHashCash.getFormData(form, 'elhc_stamp');
        var elhc_difficulty = elementsHashCash.getFormData(form, 'elhc_difficulty');

        // check to see if we already found a solution
        var form_nonce = elementsHashCash.getFormData(form, 'elhc_nonce');
        if (form_nonce && elementsHashCash.checkNonce(elhc_difficulty, elhc_stamp, form_nonce)) {
            // we have a valid nonce; submit the form
            // form.submit()
            // document.getElementById('submitbutton').disabled = false;
            return true;
        }
        var nonce = 1;

        while (!elementsHashCash.checkNonce(elhc_difficulty, elhc_stamp, nonce)) {
            nonce++;
            if (nonce % 10000 == 0) {
                let remaining = Math.round((Math.pow(2, elhc_difficulty) - nonce) / 10000) * 10000;
                var text = "     Approximately " + remaining + " hashes remaining before form unlocks."
                console.log(text)
                //document.getElementById('countdown').innerHTML = text;

                await elementsHashCash.sleep(100); // don't peg the CPU and prevent the browser from rendering these updates
            }
        }

        elementsHashCash.setFormData(form, 'elhc_nonce', nonce);

        // we have a valid nonce; enable the form submit button
        // document.getElementById('countdown').innerHTML = "a";
        //form.submit()

        return true;
    }

}

/**
 * Start the HashCash Script for every Form where form has the Class: .js-elhc-form
 *
 * This searches the forms submit button and prevents the form submit until the test is done correct
 */
window.addEventListener('load', (event) => {
    // let allAjaxForms = findAll('.js-elhc-form-ajax');

    // allAjaxForms.forEach((formElement) => {
    $('.js-elhc-form-ajax').each(function() {
        let $base = $(this);
        if (!$base.hasClass('loaded')) {
            console.log('in if');
            fetch('/elhc/ajax/create-stamp?uri=' + encodeURI(location.href) + "&time=" + (new Date()).getTime()).then(function (response) {
                return response.json();
            }).then(function (data) {
                for (const property in data) {
                    var input = document.createElement("input");
                    input.type = "hidden";
                    input.name = property;
                    input.value = data[property];
                    base.appendChild(input);
                }
            }).catch(function (err) {
                console.log('Fetch Error :-S', err);
            })
        }
        base.addClass('loaded');
    });

    // var allForms = document.querySelectorAll('.js-elhc-form');
    // allForms.forEach((formElement) => {
    $('.js-elhc-form').each(function() {
        let $base = $(this);
        $base.find(':input[type=submit]').on('click', (event) => {
            event.preventDefault();
            whenValid($base).then(function (isValid) {
                if (isValid) {
                    var submittedForm = $base[0];
                    var submitButtons = submittedForm.querySelectorAll('button[type="submit"], button:not([type])');
                    submitButtons.forEach((el) => {
                        el.setAttribute('disabled', true)
                    });
                    elementsHashCash.findHash(submittedForm).then((isValid) => {
                        var newAction = submittedForm.getAttribute('data-action')
                        var hasActionAttr = submittedForm.hasAttribute('data-action')
                        if (hasActionAttr) {
                            submittedForm.action = newAction;
                        }

                        var customEvent = new CustomEvent('hashcashFormValid', {
                            bubbles: true,
                            detail: {
                                valid: isValid,
                                submitForm: true
                            }
                        })
                        submittedForm.dispatchEvent(customEvent)

                        if (customEvent.detail.submitForm && customEvent.detail.valid) {
                            submittedForm.submit();
                        }
                    });
                }
            });
        });
    });
});








